<template>
  <Teleport to="body">
  <div class="modal" :class="{ 'is-active': isActive }" style="z-index: 100;">
    <div class="modal-background" @click="$emit('close')"></div>
    <div class="modal-card">
      <header class="modal-card-head has-background-danger">
        <p class="modal-card-title has-text-white">Dependencies Not Met</p>
        <button class="delete" aria-label="close" @click="$emit('close')"></button>
      </header>
      <section class="modal-card-body">
        <p class="mb-3">
          The following dependencies are incomplete for moving to
          <strong>{{ targetStageLabel }}</strong>:
        </p>
        <div class="blockers-list">
          <div
            v-for="blocker in blockers"
            :key="blocker.id"
            class="blocker-item"
          >
            <span class="tag is-small mr-2" :class="blocker.type === 'review' ? 'is-link' : 'is-info'">
              {{ blocker.type }}
            </span>
            <span class="blocker-title">{{ blocker.title }}</span>
            <span class="has-text-grey is-size-7 ml-2">({{ blocker.currentStage }})</span>
          </div>
        </div>
        <p class="mt-4 has-text-grey is-size-7">
          Advancing anyway may result in an incomplete client review. This action will be logged.
        </p>
      </section>
      <footer class="modal-card-foot is-justify-content-flex-end">
        <button class="button is-text has-text-grey" @click="$emit('close')">
          Cancel
        </button>
        <button class="button is-danger" @click="$emit('override')">
          Override &amp; Advance
        </button>
      </footer>
    </div>
  </div>
</teleport></template>

<script setup>
import { computed } from 'vue'
import { DELIVERABLE_STAGE_CONFIG } from '@/utils/deliverableUtils'

const props = defineProps({
  isActive: { type: Boolean, default: false },
  blockers: { type: Array, default: () => [] },
  targetStage: { type: String, default: '' },
})

defineEmits(['close', 'override'])

const targetStageLabel = computed(() => {
  return DELIVERABLE_STAGE_CONFIG[props.targetStage]?.label || props.targetStage
})
</script>

<style scoped>
.modal-card {
  max-width: 520px;
  width: 90%;
  margin: 0 auto;
}

.modal-card-body {
  padding: 1.5rem;
}

.modal-card-foot {
  padding: 1rem 1.5rem;
}

.modal-card-head.has-background-danger {
  border-bottom: none;
}

.blockers-list {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.blocker-item {
  display: flex;
  align-items: center;
  padding: 0.4rem 0.6rem;
  background: hsl(0, 0%, 96%);
  border-radius: 4px;
}

.blocker-title {
  font-weight: 600;
  font-size: 0.875rem;
}
</style>
